class LoaderController {
    constructor() {
        'ngInject';

        this.name = 'loader';
    }
}

export default LoaderController;



// WEBPACK FOOTER //
// ./client/app/common/loader/loader.controller.js